import {Container, Typography} from '@material-ui/core';

export default function Privacy(props) {
  return (
    <Container>
      <Typography variant="h3">Privacy Policy</Typography>
      <Typography variant="h5">Effective Date: [2025-08-22]</Typography>
      <Typography variant="body1">
        Medinetwork INC., located at Montreal, Quebec, Canada, respects and
        protects your personal health information (PHI) and personal information
        (PI). We comply with applicable privacy laws, including the Health
        Insurance Portability and Accountability Act (HIPAA) in the United
        States and the Personal Information Protection and Electronic Documents
        Act (PIPEDA) in Canada.
      </Typography>
      <Typography variant="h5">Information We Collect</Typography>
      <Typography variant="body1">
        When you use our application, we may collect the following information:
        <br />• Name <br />• Date of Birth <br />• Health Card Number <br />•
        Email Address <br />• Mobile Phone Number <br />• Appointment Details
        (e.g., date, time, clinic, provider)
      </Typography>
      <Typography variant="h5">Purpose of Collection</Typography>
      <Typography variant="body1">
        We collect and use your personal information only for the following
        purposes: <br />
        • Scheduling and managing medical appointments
        <br />
        • Sharing necessary information with clinics, hospitals, or healthcare
        providers with whom we have formal agreements
        <br />
        • Communicating with you regarding your appointments
        <br />
        We will not use your information for any purpose other than those
        described above without your consent, unless required by law.
      </Typography>
      <Typography variant="h5">Data Sharing</Typography>
      <Typography variant="body1">
        Your personal information will be shared only with:
        <br />
        • Clinics, hospitals, and healthcare providers who need the information
        to provide appointment services
        <br />
        • Service providers under contract with us who assist in operating the
        app (with appropriate privacy safeguards)
        <br />
        We do not sell, rent, or disclose your personal information to third
        parties outside of the above scope.
      </Typography>
      <Typography variant="h5">Data Retention</Typography>
      <Typography variant="body1">
        We retain your personal information only for as long as necessary to
        fulfill the purposes described in this policy or as required by law.
        Once the information is no longer needed, it will be securely deleted or
        anonymized.
      </Typography>
      <Typography variant="h5">Your Rights</Typography>
      <Typography variant="body1">
        You have the right to:
        <br />
        • Access the personal information we hold about you
        <br />
        • Request correction or updates to your information
        <br />
        • Withdraw your consent to processing (subject to legal or contractual
        restrictions)
        <br />
        • Request deletion of your data where applicable
        <br />
        To exercise these rights, please contact us (see Contact Us below).
      </Typography>
      <Typography variant="h5">Security</Typography>
      <Typography variant="body1">
        We take reasonable administrative, technical, and physical measures to
        protect your personal information from unauthorized access, disclosure,
        alteration, or misuse. While no system can guarantee 100% security, we
        continually update our practices to safeguard your data.
      </Typography>
      <Typography variant="h5">Children’s Privacy</Typography>
      <Typography variant="body1">
        Our application is not directed to children under the age of 13. We do
        not knowingly collect personal information from children. If we become
        aware that we have inadvertently collected such information, we will
        delete it promptly.
      </Typography>
      <Typography variant="h5">Cross-Border Data Transfers</Typography>
      <Typography variant="body1">
        If you are located outside of Canada or the United States, please note
        that your information may be transferred and stored in these countries,
        where privacy laws may differ from those in your jurisdiction. We will
        ensure appropriate safeguards are in place when such transfers occur.
      </Typography>
      <Typography variant="h5">Updates to This Policy</Typography>
      <Typography variant="body1">
        We may update this Privacy Policy from time to time. Any changes will be
        posted within the app and on this webpage with an updated “Effective
        Date.”
      </Typography>
      <Typography variant="h5">Contact Us</Typography>
      <Typography variant="body1">
        If you have any questions or concerns about this Privacy Policy or how
        your personal information is handled, please contact us at:
        <br />
        <br />
        Medinetwork INC. <br />
        Email: contactus@cliniplusapp.com
      </Typography>
    </Container>
  );
}
